import { beautifyEnum } from 'src/utils/utility';

// Helper function to create filter items from metadata
export const createFilterItems = (items?: Record<string, number>, columnKey?: string) => {
  // Handle empty or undefined input
  if (!items) return [];

  // Entity columns that need beautifyEnum + uppercase
  const entityColumns = ['billedEntity', 'shipper', 'consignee'];
  const shouldBeautify = columnKey && entityColumns.includes(columnKey);

  // Items is in the format { value: count }
  // Convert to array, map to filter items, and sort alphabetically by label
  return Object.entries(items)
    .map(([value, count]) => {
      let label = !value || value === 'null' ? '(Blanks)' : value;

      // Apply beautifyEnum + uppercase for entity columns
      if (shouldBeautify && label !== '(Blanks)') {
        label = beautifyEnum(String(label)).toUpperCase();
      }

      return {
        id: value === 'null' ? null : value,
        label,
        count: Number(count),
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
};
